import React, { useState } from 'react';
import { View, TouchableOpacity } from 'react-native';
import i18n from 'i18n-js';

import { Alert } from '@helpers';
import { width, scale, notchTop } from '@components/frame';
import ActionMenu from '@components/common/actionMenu';
import ColorWrapper from '@styles/colors';

const ActionsModal = (props) => {
  const { C, setShowMorePopup, toggleEditGroupName, removeAction } = props;
  const [removing, setRemoving] = useState(false);

  const items = [
    {
      lable: {
        color: 'Label/Light/Primary',
        name: 'Edit Machine Group Name',
      },
      icon: {
        name: 'edit',
        width: 12,
        height: 12,
        color: 'Label/Light/Primary',
      },
      onPress: () => {
        setShowMorePopup(false);
        toggleEditGroupName();
      },
    },
    {
      lable: {
        color: 'Label/Light/Warning',
        name: 'Remove',
      },
      icon: {
        name: 'remove',
        width: 15,
        height: 17,
        color: 'Label/Light/Warning',
      },
      isLoading: removing,
      onPress: () => {
        setShowMorePopup(false);
        Alert({
          title: i18n.t('Are you sure?'),
          actions: [
            {
              text: i18n.t('Cancel'),
              onPress: () => {},
              style: 'primary',
            },
            {
              text: i18n.t('Remove'),
              style: 'danger',
              onPress: async () => {
                setRemoving(true);
                await removeAction();
                setRemoving(false);
              },
            },
          ],
        });
      },
    },
  ];

  return (
    <View
      style={{
        width: '100%',
        height: '100%',
        position: 'absolute',
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: C('Overlay/Light/Dim light'),
      }}
    >
      <TouchableOpacity style={{ width: '100%', height: '100%', alignItems: 'center' }} onPress={() => setShowMorePopup(false)} activeOpacity={1}>
        <View style={{ width: '100%', height: '100%', justifyContent: 'center', alignItems: 'center', alignContent: 'center' }}>
          <View
            style={{
              position: 'absolute',
              top: scale(60) + notchTop,
              right: scale(18),
              backgroundColor: C('Background/Light/Field'),
              borderRadius: scale(12),
            }}
          >
            <ActionMenu {...{ C, items }} />
          </View>
        </View>
      </TouchableOpacity>
    </View>
  );
};

export default ColorWrapper(ActionsModal);
